module.exports = __webpack_public_path__ + "img/user-icon-placeholder.295af695.png";